import React from 'react';

import { Link } from '@ergeon/core-components';
import { PhoneIcon } from '@ergeon/icons/hero/micro';

interface CallMessageProps {
  durationStr?: string | null;
  recordingUrl?: string | null;
}

export const CallMessage: React.FC<CallMessageProps> = ({ durationStr, recordingUrl }) => (
  <div className="flex gap-2">
    <div className="flex items-center gap-1">
      <PhoneIcon className="size-4" />
      Call - {durationStr || 'Unknown duration'}
    </div>
    {recordingUrl && (
      <Link href={recordingUrl} target="_blank">
        Recording available
      </Link>
    )}
  </div>
);
